import ComparisonCasesList from '@/components/comparisons/ComparisonCasesList';
import ComparisonsReport from '@/components/comparisons/ComparisonsReport';
import { Suspense, useEffect, useRef } from 'react';
import { Await, Outlet, useLoaderData } from 'react-router';
import WalkthroughButton from '@/components/core/WalkthroughButton';
import { comparisonActions } from '@/stores/comparisonStore';
import ComparisonExportButton from '@/components/comparisons/ComparisonExportButton';

const ComparisonRoute = () => {
  const data = useLoaderData();
  const blockRef = useRef(null);

  useEffect(() => {
    comparisonActions.unmount();
    blockRef.current.focus();
  }, []);

  return (
    <div className="bg-canvas focus:outline-none" ref={blockRef} tabIndex={-1}>
      <WalkthroughButton type="comparison" parentRef={blockRef} />
      <Suspense
        fallback={
          <div className="pl-8 pt-6">
            <span className="loading loading-dots loading-md"></span>
          </div>
        }
      >
        <Await resolve={data.comparisonData} errorElement={<></>}>
          {comparison => (
            <>
              <div className="flex float-right mt-4">
                <ComparisonExportButton comparisonId={comparison.id} name={comparison.name} />
              </div>
              <div className="relative prose prose-sm px-6 py-5">
                <h3>{comparison?.name}</h3>
              </div>
              <ComparisonCasesList />
              <ComparisonsReport />
              <Outlet />
            </>
          )}
        </Await>
      </Suspense>
    </div>
  );
};

export default ComparisonRoute;
